import { Component, AfterViewInit, inject, Input, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackPinsDashboardComponent } from './feedback-pins-dashboard/feedback-pins-dashboard.component';
import { KeyResultDashboardComponent } from './key-result-dashboard/key-result-dashboard.component';
import { Router, UrlTree } from '@angular/router';
import { AiService } from '../../../../service/ai.service';
import { AppdataService } from '../../../../service/appdata.service';
import { TrackResult } from '../../../../interfaces/responsedata.ts/trackresults';
import { TrackService } from '../../../../service/track.service';

export interface DropDownTrackMenue {
  status: string;
  itemName: string;
  routerLink?: UrlTree | string;
  progress?: number
}

@Component({
  selector: 'rr-detail-track-row',
  standalone: false,
  templateUrl: './detail-track-row.component.html',
  styleUrl: './detail-track-row.component.scss'
})
export class DetailTrackRowComponent implements AfterViewInit {
  // Injections
  readonly dialog = inject(MatDialog)
  readonly router = inject(Router)
  readonly aiService = inject(AiService);
  readonly appData = inject(AppdataService);
  cd = inject(ChangeDetectorRef);
  trackService = inject(TrackService);

  // Inputs
  @Input() track: any;

  // Variables
  shipStatus: boolean = false; // true wenn 30 Feedbackpins da sind
  feedbackPinCounter: number = 0;
  minimalFeedBacksForBMC: number = 30
  feedbackCardResult: any = {};
  feedbackStepId: string = "";
  feedbackStreamId: string = "";


  // Objects
  streams: any[] = [];
  menueList: DropDownTrackMenue[] = [];
  continueLink: UrlTree = new UrlTree();
  trackReports: any[] = [];

  async ngAfterViewInit(): Promise<void> {

    this.continueLink = await this.generateContinueLink();
    this.cd.detectChanges();

  }
  async deleteTrack() {
    if (!this.track.roundId) return;
    let i = await confirm('Do you really want to delete the Stream and all Stream-Data?');
    if (i === false) return;

    let result = await this.trackService.deleteTrack(this.track.roundId);
    console.log(result);

    if (result === true) {
      this.trackService.loadUserTrackData();
    }
  }
  async generateContinueLink(): Promise<UrlTree> {
    let link: any;

    // === QUALIFY ====
    let qualify = await this.track.results?.find((result: TrackResult) => result.streamId === "J1S-8At2nL");
    if (qualify) {
      // Get last Step in Validate Results
      let lastStepId = qualify.stepResults[qualify.stepResults.length - 1].stepId;
      if (lastStepId) {
        link = await this.router.createUrlTree(['new-track-run', this.track.trackData.id], {
          queryParams: {
            streamId: qualify.streamId,
            stepId: lastStepId,
            roundId: this.track.roundId
          }
        });
      }
      // Calculate Stream-Progress
      let progress = qualify.stepResults.length / 5 * 100;
      console.log("Progress", progress);
      if (progress === 100) {
        link = await this.router.createUrlTree(['new-track-run', this.track.trackData.id], {
          queryParams: {
            streamId: "J1S-8At2nL",
            stepId: "closing-stream",
            roundId: this.track.roundId
          }
        });
      }

      let status = progress === 100 ? "ready" : "active"
      this.menueList.push({
        status: status,
        itemName: "Qualify",
        routerLink: link,
        progress: progress
      });
    } else {
      // First Step for continue
      link = await this.router.createUrlTree(['new-track-run', this.track.trackData.id], {
        queryParams: {
          streamId: "J1S-8At2nL",
          stepId: "MMUT2vQla",
          roundId: this.track.roundId
        }
      });

      this.menueList.push({
        status: "active",
        itemName: "Qualify",
      });
    }


    // === VALIDATE ====
    let validate: TrackResult | undefined = this.track.results?.find((result: TrackResult) => result.streamId === "4dXLpB4Ll");
    if (validate) {
      link = await this.router.createUrlTree(['new-track-run', this.track.trackData.id], {
        queryParams: {
          streamId: "J1S-8At2nL",
          stepId: "closing-stream",
          roundId: this.track.roundId
        }
      });


      // // Get pin Counts
      // let result = await validate?.stepResults?.find(
      //   (r: any) => r.stepId == "k9G9Fv8w6"
      // );
      // if (result) {
      //   this.feedbackCardResult = result.result
      //   this.feedbackPinCounter = this.feedbackCardResult.pins?.length || 0;
      //   this.feedbackStepId = result.stepId || "";
      // }
      // // Get last Step in Validate Results
      // let lastStepId = validate.stepResults[validate.stepResults.length - 1].stepId;
      // if (lastStepId) {
      //   link = this.router.createUrlTree(['new-track-run', this.track.trackData.id], {
      //     queryParams: {
      //       streamId: validate.streamId,
      //       stepId: lastStepId,
      //       roundId: this.track.roundId
      //     }
      //   });
      // }
      // // Calculate Stream-Progress
      // let progress = validate.stepResults.length / 1 * 100;
      // let status = progress === 100 ? "ready" : "active"
      // if (this.feedbackPinCounter !== this.minimalFeedBacksForBMC && progress === 100) {
      //   status = "active"
      // }

      // this.menueList.push({
      //   status: status,
      //   itemName: "Validate",
      //   routerLink: link,
      //   progress: progress
      // });
      // } else {
      // // First Step for continue
      // this.menueList.push({
      //   status: "inactive",
      //   itemName: "Validate",
      // })
    }


    // // === SHIP ===
    // this.menueList.push({
    //   status: this.feedbackPinCounter === this.minimalFeedBacksForBMC ? "active" : "inactive",
    //   itemName: "Ship"
    // })

    return link?.toString();
  }
  async openKeyResultDashboard() {
    this.dialog.open(KeyResultDashboardComponent, {
      autoFocus: false,
      panelClass: "wide-dialog",
      data: { "results": this.track.results, "streams": this.track.trackData.streams, "ship": [], "track": this.track }
    });
  }
  async openFeedbackPinDashbord() {
    this.dialog.open(FeedbackPinsDashboardComponent, {
      panelClass: "feed-back-card",
      autoFocus: false,
      data: {
        "name": this.track.name,
        "feedbackCardResult": this.feedbackCardResult,
        "trackId": this.track.trackId,
        "roundId": this.track.roundId,
        "streamId": this.feedbackStreamId,
        "results": this.track.results,
        "stepId": this.feedbackStepId
      }
    });
  }
}
